import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import {
  VigilantApiDtoRealm,
} from "./realms.model";

@Injectable({ providedIn: "root" })
export class VigilantRealmsService {

  constructor(private http: HttpClient) { }

  url = environment.vigilantApiUrl;

  getAllRealms(): Observable<VigilantApiDtoRealm[]> {
    return this.http.get<VigilantApiDtoRealm[]>(`${this.url}/api/realms`);
  }

  createRealm(realm: VigilantApiDtoRealm): Observable<VigilantApiDtoRealm> {
    return this.http.post<VigilantApiDtoRealm>(`${this.url}/api/realms`, realm);
  }

  getRealmById(id: number): Observable<VigilantApiDtoRealm> {
    return this.http.get<VigilantApiDtoRealm>(`${this.url}/api/realms/${id}`);
  }

  getAllActiveRealms(): Observable<VigilantApiDtoRealm[]> {
    return this.http.get<VigilantApiDtoRealm[]>(`${this.url}/api/realms/active`);
  }

  updateRealm(id: number, realm: VigilantApiDtoRealm): Observable<VigilantApiDtoRealm> {
    return this.http.patch<VigilantApiDtoRealm>(`${this.url}/api/realms/${id}`, realm);
  }

  deleteRealm(id: number): Observable<unknown> {
    return this.http.delete<unknown>(`${this.url}/api/realms/${id}`);
  }
}
